import "../styles/footer.css";

import { HashLink } from "react-router-hash-link";

import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRegClock,
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="0">
      <div className="footer-container">

        {/* Left */}

        <div className="footer-column">

          <h2>Jagadish Hearing Aids</h2>

          <p>
            The Art of Conversation is the Art of Hearing as well as of Being
            Heard...
          </p>

          <div className="social-icons">
            <a
              href="https://www.instagram.com/jagadish_hearing_aids/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>

            <a href="mailto:jagadishhearingaidschennai@gmail.com">
              <FaEnvelope />
            </a>
          </div>

        </div>

        {/* Menu */}

        <div className="footer-column">

          <h2>Menu</h2>

          <ul className="footer-menu">

            <li>
              <HashLink smooth to="/about">
                About Us
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/services">
                Services
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/products">
                Products
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/hearing">
                Hearing
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/#models">
                Models
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/#why-us">
                Why Us
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/location">
                Location
              </HashLink>
            </li>

          </ul>

        </div>

        {/* Contact */}

        <div className="footer-column">

          <h2>Get in Touch</h2>

          <div className="contact-item">
            <FaMapMarkerAlt className="icon" />
            <p>New No.5, Old No.3, Kutchery Road, Mylapore, Chennai - 600004

            </p>
          </div>

          <div className="contact-item">
            <FaPhoneAlt className="icon" />
            <p>+91 94448 51663, +91 94451 15548</p>
          </div>

          <div className="contact-item">
            <FaEnvelope className="icon" />
            <p>jagadishhearingaidschennai@gmail.com</p>
          </div>

          <div className="contact-item">
            <FaRegClock className="icon" />
            <p>Mon - Sat | 10:00 AM - 07:00 PM</p>
          </div>

        </div>

      </div>

      <div className="copyright">
        © {new Date().getFullYear()} Jagadish Hearing Aids. All Rights Reserved.
      </div>

    </footer>
  );
}

export default Footer;